<template>
  <div class="market-vcr-check-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="90" @onSearch="onSearch">
      <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <div class="statistics-box">
      <div class="statistics-item" v-for="(item) in statisticsData" :key="item.title">
        <div class="icon-box">
          <img :src="item.icon" class="img">
        </div>
        <div class="right-box">
          <div class="title">{{ item.title }}</div>
          <div class="amount">{{ item.amount }}</div>
        </div>
      </div>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #phone="{ row, scope }">
        <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #cardStoreName="{ row }">{{ row.cardStoreName }}</template>
      <template #paymentOrderId="{ row }">{{ row.paymentOrderId }}</template>
      <template #amount="{ row }">{{ row.amount }}</template>
      <template #storedCardSource="{ row }">{{ row.storedCardSource }}</template>
      <template #payTime="{ row }">{{ row.payTime ? $moment(row.payTime).format('YYYY/MM/DD HH:mm:ss') : '' }}</template>
      <template #refundTime="{ row }">{{ row.refundTime ? $moment(row.refundTime).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #scene="{ row }">{{ row.scene }}</template>
      <template #payType="{ row }">{{ row.payType }}</template>
      <template #source="{ row }">{{ row.source }}</template>
    </Table>
  </div>
</template>

<script>
import aes from '@/common/aes.js'
import { downFile } from "@/utils";
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import { api_getUserPhone } from '@/api/common'
import { api_postCheckCancelCardRecordList, api_postCheckCancelCardRecordExport } from '@/api/market'
export default {
  name: "mvcrCheck",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "储值卡名称",
          placeholder: "请选择储值卡名称",
          type: "input",
          key: "name",
        },
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone",
        },
        {
          label: "支付时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "time",
          valueFormat: 'timestamp'
        },
        {
          label: "订单来源",
          placeholder: "请选择订单来源",
          type: "select",
          multiple: false,
          key: "source",
          option: [{
            value: 'WechatMiniapp',
            label: '微信小程序'
          },{
            value: 'AlipayMiniapp',
            label: '支付宝小程序'
          }],
        },
        {
          label: "订单号",
          placeholder: "请输入订单号",
          type: "input",
          key: "paymentOrderId",
        }
      ],
      form: {},
      tableKey: false,
      tableThData: [
        { prop: "phone", label: "会员手机号", minWidth: "160", },
        { prop: "name", label: "储值卡名称", minWidth: "180", },
        { prop: "cardStoreName", label: "核销店铺", minWidth: "180", },
        { prop: "paymentOrderId", label: "订单号", minWidth: "180", },
        { prop: "amount", label: "核销金额(元)", minWidth: "120", },
        { prop: "payTime", label: "支付时间", minWidth: "180", },
        { prop: "refundTime", label: "退款时间", minWidth: "180", },
        { prop: "storedCardSource", label: "数据来源", minWidth: "100", },
        { prop: "scene", label: "交易类型", minWidth: "100", },
        { prop: "payType", label: "支付方式", minWidth: "100", },
        { prop: "source", label: "订单来源", minWidth: "120", },
      ],
      statisticsData: [
        {
          key: 'totalConsumeAmount',
          title: '累积核销（元）',
          icon: require("@/assets/market_images/statistics-icon01.png"),
          amount: 999.99
        },
        {
          key: 'totalWithdrawalAmount',
          title: '累积撤销（元）',
          icon: require("@/assets/market_images/statistics-icon02.png"),
          amount: 888.88
        },
        {
          key: 'todayConsumeAmount',
          title: '今日核销（元）',
          icon: require("@/assets/market_images/statistics-icon03.png"),
          amount: 888.88
        },
        {
          key: 'todayWithdrawalAmount',
          title: '今日撤销（元）',
          icon: require("@/assets/market_images/statistics-icon04.png"),
          amount: 888.88
        },
      ],
      exportLoading: false,
    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      try {
        let params = {
          ...this.form,
          offset: this.offset,
          limit: this.limit,
        }
        this.$router.push({query: params})
        params.createdFrom = this.form.time ? this.form.time[0] : null
        params.createdTo = this.form.time ? this.form.time[1] : null
        delete params.time
        const { page, storedCardTodayTradeVO, storedCardTotalTradeVO } = await api_postCheckCancelCardRecordList(params)
        console.log('page: ', page);
        this.tableTrData = page.list || []
        this.total = page.count
        this.setStatisticsData(storedCardTodayTradeVO, storedCardTotalTradeVO)
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    // 统计数据赋值
    setStatisticsData(today={}, total={}) {
      const data = {...today, ...total}
      this.statisticsData.forEach(item => {
        item.amount = typeof data[item.key] == 'number' ? data[item.key] : '-'
      })
    },

    // 导出
    async onExport() {
      this.exportLoading = true
      let params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.form.time && (params.createdFrom = this.form.time ? this.form.time[0] : null)
      this.form.time && (params.createdTo = this.form.time ? this.form.time[1] : null)
      delete params.time
      let res = await api_postCheckCancelCardRecordExport(params)
      console.log(res)
      downFile(res)
      this.exportLoading = false
    },

    // 点击查看手机号
    async onLookPhone(row, index) {
      try {
        if (row.phone_show) {
          delete this.tableTrData[index].phone_show
        } else {
          const {phone} = await api_getUserPhone({id: row.userId})
          this.tableTrData[index].phone_show = aes.decrypt(phone)
        }
        this.tableKey = !this.tableKey
      } catch (error) {
        console.log('error: ', error);
      }
    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-vcr-check-index {
  width: 100%;
  padding: 0;
  box-sizing: border-box;

  .el-button {
    min-width: 80px !important;
  }

  .statistics-box {
    padding: 10px 0;
    display: flex;
    border-bottom: 1px solid #cccccc80;
    overflow-x: auto;

    .statistics-item {
      min-width: 230px;
      height: 80px;
      border-right: 1px solid #cccccc80;
      display: flex;
      align-items: center;

      .icon-box {
        margin-left: 40px;
        width: 40px;
        height: 40px;

        .img {
          width: 100%;
          height: 100%;
        }
      }

      .right-box {
        margin-left: 10px;

        .title {
          font-size: 12px;
          color: #666;
          margin-bottom: 10px;
        }

        .amount {
          font-size: 20px;
          font-weight: 500;
          color: #333;
        }
      }

      &:last-child {
        border-right: none;
      }
    }
  }
}
</style>
